import { render, staticRenderFns } from "./RedemptionPage.vue?vue&type=template&id=1ec9d998&scoped=true"
import script from "./RedemptionPage.vue?vue&type=script&lang=js"
export * from "./RedemptionPage.vue?vue&type=script&lang=js"
import style0 from "./RedemptionPage.vue?vue&type=style&index=0&id=1ec9d998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9d998",
  null
  
)

export default component.exports